import React from 'react';
import { MultiColumnEntry, MultiColumnEntryProps } from '../MultiColumnEntry/MultiColumnEntry';
import { styles } from './MultiColumnBlock.css';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';
import { useMediaQuery } from '@jbhi-fi/lanyard-ui/utils/useMediaQuery';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export interface MultiColumnBlockProps {
  entries: Array<Omit<MultiColumnEntryProps, 'alignment'>>;
  desktopColumns: 2 | 3 | 4 | 5;
  mobileFormat: 'Stack' | 'Double' | 'Carousel';
  alignment: 'Left' | 'Centred';
  theme?: ContentThemePalette;
  heading?: string;
}

export const MultiColumnBlock: React.FC<MultiColumnBlockProps> = ({
  heading,
  entries,
  desktopColumns = 3,
  mobileFormat,
  alignment,
  theme,
}) => {
  const isDesktop = useBreakpoint('md', 'up');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 992px)');
  const isCentred = alignment === 'Centred';
  // We need to set the number of columns to 4 for tablets when the desktopColumns is 5
  const desktopCount = isTablet && desktopColumns === 5 ? 4 : desktopColumns;
  const mobileCount = mobileFormat === 'Double' ? 2 : 1;
  const columns = isDesktop ? desktopCount : mobileCount;

  const items = entries?.map((entry, index) => <MultiColumnEntry key={index} {...entry} alignment={alignment} />);

  return (
    <>
      {heading ? <CalloutFont as="h2">{heading}</CalloutFont> : null}
      <div
        className={styles.container({ isCentred })}
        style={{
          backgroundColor: theme?.background,
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
        }}
      >
        {!isDesktop && mobileFormat === 'Carousel' ? (
          <Carousel slidesPerView={1.2} showPagination={false} fullBleed fullHeightItems showArrows={false}>
            {items}
          </Carousel>
        ) : (
          items
        )}
      </div>
    </>
  );
};
